import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ChannelRateLimitsResponse, UpdateChannelRateLimitsRequest } from '@troia-v3/types';
import { channelsApi } from '../services';

export const useUpdateChannelRateLimits = (channelId: string) => {
  const queryClient = useQueryClient();
  return useMutation<ChannelRateLimitsResponse, Error, UpdateChannelRateLimitsRequest>({
    mutationFn: (body) => channelsApi.updateRateLimits(channelId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['channels', channelId, 'rate-limits'] });
    },
  });
};
